import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { ApiResponse } from 'src/app/shared/interfaces/api-response.interface';
import { CaixaConferencia } from 'src/app/shared/components/fechamento-caixa-dialog/fechamento-caixa-dialog.component';
import { CaixaConferenciaRequest } from 'src/app/shared/models/caixa-conferencia-request';
import { CaixaResponse } from 'src/app/shared/models/caixa-response';
import { AberturaCaixaRequest } from 'src/app/shared/models/abertura-caixa-request';
import { BehaviorSubject } from 'rxjs';
import { SangriaSuprimentoRequest } from 'src/app/shared/models/sangria-suprimento-request';

@Injectable({
  providedIn: 'root'
})
export class CaixaService {
  public caixaAberto$ = new BehaviorSubject(false);

  constructor(
    private _httpClient: HttpClient,
    private _authService: AuthenticationService
  ) { }

  private get base() {
    return `${this._authService.baseUrl}/Caixa`;
  }

  public abrirCaixa(request: AberturaCaixaRequest) {
    return this._httpClient.post<ApiResponse>(`${this.base}/AbrirCaixa`, request);
  }

  public fecharCaixa(conferencias: CaixaConferenciaRequest) {
    return this._httpClient.post<ApiResponse>(`${this.base}/FecharCaixa`, conferencias);
  }

  public inserirSangriaOuSuprimento(request: SangriaSuprimentoRequest) {
    return this._httpClient.post<ApiResponse>(`${this.base}/InserirSangriaOuSuprimento`, request);
  }

  public obterCaixaPorCodigoUsuario(codigoUsuario: number, numeroCaixa: number) {
    return this._httpClient.get<ApiResponse<CaixaResponse>>(`${this.base}/ObterCaixaPorCodigoUsuario/${codigoUsuario}/${numeroCaixa}`);
  }

  public obterDadosFechamentoCaixa(numeroCaixa: number) {
    return this._httpClient.get<ApiResponse<CaixaConferencia[]>>(`${this.base}/ObterDadosFechamentoCaixa/${numeroCaixa}` );
  }

  public obterDadosUltimoCaixa(codigoCaixa: number) {
    return this._httpClient.get<ApiResponse<CaixaResponse>>(`${this.base}/ObterDadosUltimoCaixa/${codigoCaixa}`);
  }

  public verificarCaixaAberto() {
    return this._httpClient.get<ApiResponse<CaixaResponse>>(`${this.base}/VerificarCaixaAberto/${this._authService.numeroCaixa}`);
  }
}
